import api from "../api"

export const riskAPI={
	async getAll(MatrixID){
		let value = await api.get(`/risk/` , { params: { MatrixID: MatrixID } })
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	},
	async createRisk(MatrixID,Risk, RiskDescription, TypesOfRisk, RiskOwner, Created, Creator, Consequence, Probability){
		let value = await api.post(`/risk/`,{
			MatrixID: MatrixID,
			Risk: Risk,
			RiskDescription: RiskDescription,
			TypesOfRisk: TypesOfRisk,
			RiskOwner: RiskOwner,
			Created: Created,
			Creator: Creator,
			Consequence: Consequence,
			Probability: Probability
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},	async deleteRisk(ID) {
		if (isNaN(parseInt(ID))) {
			throw Error("ID must be a number")
		}
		let value = await api.delete(`/risk/${ID}`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return true
	}, async getRiskById(ID){
		if(isNaN(parseInt(ID))){
			throw Error("ID must be a number")
		}
		let value = await api.get(`/risk/${ID}`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	}, async updateRiskById(ID,Risk, RiskDescription, TypesOfRisk, RiskOwner, Created, Creator, Consequence, Probability){
		if(isNaN(parseInt(ID))){
			throw Error("ID must be a number")
		}
		let value = await api.put(`/risk/${ID}`,{
			Risk: Risk,
			RiskDescription: RiskDescription,
			TypesOfRisk: TypesOfRisk,
			RiskOwner: RiskOwner,
			Created: Created,
			Creator: Creator,
			Consequence: Consequence,
			Probability: Probability
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	}, async updateRiskNewPointById(ID, UpdatedDate, UpdatedConsequence, UpdatedProbability, CommentforUpdate){
		if(isNaN(parseInt(ID))){
			throw Error("ID must be a number")
		}
		let value = await api.put(`/risk/${ID}/update`,{
			UpdatedDate: UpdatedDate,
			UpdatedConsequence: UpdatedConsequence,
			UpdatedProbability: UpdatedProbability,
			CommentforUpdate: CommentforUpdate,
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
	async riskHistory(ID, UpdatedDate, UpdatedConsequence, UpdatedProbability, CommentforUpdate){
		let value = await api.post(`/risk/${ID}/updatehistory`,{
			ID: ID,
			UpdatedDate: UpdatedDate,
			UpdatedConsequence: UpdatedConsequence,
			UpdatedProbability: UpdatedProbability,
			CommentforUpdate: CommentforUpdate,
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
	async getRiskHistory(RiskID){
		let value = await api.get(`/risk/${RiskID}/updatehistory`, { params: { RiskID: RiskID } })
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	},
	async saveProcess(processes) {
		let value = await api.post(`isoprocess`, {
			processes: processes
		})
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	},
	async viewProcess(){
		let value = await api.get(`/isoprocess`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	},
	async updateProcesses(type, processes) {
		let value = await api.put(`/isoprocess`, {
			type: type,
			processes: processes
		})
		
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	},
	async saveManagement(date, person, notes){
		let value = await api.post(`/isomanagement/`,{
			date: date,
			person: person,
			notes: notes
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
	async getManagement(){
		let value = await api.get(`/isomanagement`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	},
	async updateManagement(id, date, person, notes) {
		let value = await api.put(`/isomanagement`, {
			id: id,
			date: date,
			person: person,
			notes: notes,
		})

		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	},
	async saveIncidentManager(){
		let value = await api.post(`/incidentmanager/`)
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
	async getIncidentManager(){
		let value = await api.get(`/incidentmanager`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	},
	async loginIncident(payload) {
		let value = await api.post(`/incidentlogin`, payload)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			throw error
		}
		return value.data.data[0]
	},
	async saveIncident(clientID, type, date, description) {
		let value = await api.post(`/incident/`, {
			clientID: clientID,
			type: type,
			date: date,
			description: description
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
	async getIncident(clientID) {
		let value = await api.get(`/incident`, { params: { clientID: clientID } })
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	},
	async updateIncident(payload) {
		let value = await api.put(`/incident`, payload)
 
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	},
	async viewProcedures() {
		let value = await api.get(`/procedures`)

		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	},

	async saveProcedure(Anticorruption, Cybersecurity, Labour) {
		let value = await api.put(`/procedures`, {
			Anticorruption: Anticorruption,
			Cybersecurity: Cybersecurity,
			Labour: Labour,
		})

		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	},
}